import { Subscription } from "@apis/index";
import { deletesvg, edit, eye, switchOff, switchOn } from "@assets/icons";
import Header from "@commons/header";
import Column from "@components/column";
import Svg from "@components/svg";
import Table from "@components/table";
import { RootState } from "@store/index";
import { CreditCardIcon, Plus, Package } from "lucide-react";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const SubscriptionPackage = () => {
  const { items: subscriptions } = useSelector(
    (state: RootState) => state.subscriptions
  );
  const [page, setPage] = useState(1);

  const fetchSubscriptions = useCallback(async () => {
    await Subscription.list({ state: "subscriptions", params: { page } });
  }, []);

  useEffect(() => {
    fetchSubscriptions();
  }, [page, fetchSubscriptions]);

  const navigate = useNavigate();

  const columns = [
    {
      title: "SN",
      key: "sn",
      render: (_item: any, index: number) => index,
    },
    {
      title: "Module Name",
      key: "module",
      render: (item) => item?.module?.name,
    },
    { title: "Package Name", key: "name" },
    { title: "Pricing", key: "price" },
    {
      title: "Duration",
      key: "validityInDays",
      render: (item) => `${item.validityInDays} Days`,
    },
    {
      title: "Order Limit",
      key: "orderLimit",
      render: (item: any) => (item.isUnlimited ? "Unlimited" : item.orderLimit),
    },
    {
      title: "Status",
      key: "status",
      render: (item: any) => (
        <Svg
          src={item.isDisabled ? switchOff : switchOn}
          onClick={async () => {
            console.log(item);
            await Subscription.updateStatus({
              state: "subscriptions",
              data: { isDisabled: !item.isDisabled },
              id: item.id,
            })
              .then(() => {})
              .catch(() => {});
            fetchSubscriptions();
          }}
        />
      ),
    },
    {
      title: "Is Free",
      key: "isFree",
      render: (item: any) => (item.isFree ? "Yes" : "No"),
    },
    {
      title: "Is Unlimited",
      key: "isUnlimited",
      render: (item: any) => (item.isUnlimited ? "Yes" : "No"),
    },
  ];

  return (
    <Fragment>
      <Column>
        <Header
          title={"Subscription Package"}
          icon={CreditCardIcon}
          hasButton
          btnTitle="Add Subscription Package"
          btnIcon={<Plus width={16} />}
          onClick={() => {
            navigate(
              "/admin/subscription-management/subscription-package/create"
            );
          }}
        />
        <Table
          text="Package List"
          icon={<Package />}
          columns={columns}
          data={subscriptions}
          actions={[
            {
              key: "view",
              icon: eye,
              onClick: (item: any) =>
                navigate(
                  `/admin/subscription-management/subscription-package/update/${item.id}`,
                  { state: item }
                ),
            },
            {
              key: "edit",
              icon: edit,
              onClick: (item: any) =>
                navigate(
                  `/admin/subscription-management/subscription-package/update/${item.id}`,
                  { state: item }
                ),
            },
            {
              key: "delete",
              icon: deletesvg,
              onClick: async (item: any) => {
                await Subscription.remove({
                  state: "subscriptions",
                  id: item.id,
                })
                  .then(() => {})
                  .catch(() => {});
              },
            },
          ]}
        />
      </Column>
    </Fragment>
  );
};

export default SubscriptionPackage;
